import moment from 'moment';

export default {
  methods: {
    getDayName(dayNumber) {
      return moment().locale(this.$i18n.locale).isoWeekday(dayNumber).format('dddd');
    },
    formatTime(h, m, isCloseTime = false) {
      if (isCloseTime && h === 0 && m === 0) {
        return '24';
      }
      const hour = String(h);
      return m > 0
        ? `${hour}:${String(m).padStart(2, '0')}`
        : `${hour}`;
    },
    formatDayOpeningHours(day) {
      return `${this.formatTime(day.open_hour, day.open_minute, false)} - ${this.formatTime(day.close_hour, day.close_minute, true)}h`;
    },
    formatDate(date) {
      return moment(date).locale(this.$i18n.locale).format(this.$i18n.locale === 'sr' ? 'D. MMM YYYY.' : 'MMM D, YYYY');
    },
  },
};
